import React from "react";
import { Navigate } from "react-router-dom";

const HomePage: React.FunctionComponent = () => {
    return (
        <Navigate to="/dashboard" />
    );
}

export default HomePage;
